import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import modal from './modal.js'
import protocol from './config/protocol.js'
import ssl from './config/ssl.js'

export default contract({
  modal: array([
    modal
  ]),
  protocol: array([
    protocol
  ]),
  ssl : array([
    ssl
  ])
})
